import { ProductListReviewsCollection, ReviewsInfo } from '@reviews/const';
import { StateUtils } from '@spartacus/core';

export const REVIEWS_FEATURE = 'Reviews';
export const REVIEWS = '[Reviews] Reviews';
export const ADD_REVIEW = '[Reviews] Add review';
export const PRODUCT_LIST_REVIEW = '[Reviews] Product List Review';

export interface ReviewsFeatureState {
  reviews: StateUtils.EntityLoaderState<ReviewsInfo>;
  addReview: StateUtils.LoaderState<void>;
  productListReview: StateUtils.LoaderState<ProductListReviewsCollection>;
}

export interface StateWithReviews {
  [REVIEWS_FEATURE]: ReviewsFeatureState;
}
